import { createClient } from '@supabase/supabase-js';

// The marketing rollups live in the `marketing` schema inside the Inventory
// Supabase project (single-project architecture; see README).
// PostgREST must expose the `marketing` schema — set this in
// Supabase dashboard → Settings → API → "Exposed schemas".
const url = import.meta.env.VITE_SUPABASE_MARKETING_URL;
const key = import.meta.env.VITE_SUPABASE_MARKETING_ANON_KEY;

if (!url || !key) {
  console.warn('[supabase/marketing] missing env — frontend will run in mock mode');
}

export const marketing = createClient(url ?? 'http://localhost', key ?? 'anon', {
  auth: { persistSession: true, autoRefreshToken: true },
  db: { schema: 'marketing' },
  global: { headers: { 'x-flax-client': 'marketing-dashboard' } },
});
